export const MobileDevices = ['iPhone', 'Android', 'Windows Phone'];
